import $ from 'jquery'
import { Amplify } from 'aws-amplify'
import {
  signIn,
  confirmSignIn,
  signOut as amplifySignOut,
  getCurrentUser as amplifyGetCurrentUser,
  fetchAuthSession,
  updatePassword,
  resetPassword as amplifyResetPassword,
  confirmResetPassword,
} from 'aws-amplify/auth'

import appConfig from "./config"

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: appConfig.UserPoolId,
      userPoolClientId: appConfig.ClientId,
    }
  }
})

const postAccessToken = async () => {
  const session = await fetchAuthSession()
  return $.ajax({
    url: "/login",
    type: 'POST',
    data: {
      authenticity_token: $("#authenticity_token").val(),
      access_token: session.tokens.accessToken.toString()
    }
  })
}

export const login = async (
    email,
    password,
    newPassword = '',
    onNewPasswordRequired,
    onFailed
) => {
  try {
    if (newPassword) {
      // 新パスワード画面のボタンからもlogin()が呼ばれるため、開始済みの認証チャレンジに応答する
      const { isSignedIn, nextStep } = await confirmSignIn({ challengeResponse: newPassword })
      if (!isSignedIn) {
        throw new Error(`サインインが完了していません。追加の認証が必要です（${nextStep.signInStep}）。`)
      }
      await postAccessToken()
      return
    }

    let signInResult
    try {
      signInResult = await signIn({ username: email, password: password })
    } catch (err) {
      if (err.name !== 'UserAlreadyAuthenticatedException') {
        throw err
      }
      await amplifySignOut()
      signInResult = await signIn({ username: email, password: password })
    }

    const { isSignedIn, nextStep } = signInResult
    if (nextStep.signInStep === 'CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED') {
      onNewPasswordRequired()
      return
    }
    if (isSignedIn) {
      await postAccessToken()
    }
  } catch (err) {
    alert(err.message)
    onFailed()
  }
}

export const getCurrentUser = async () => {
  try {
    await amplifyGetCurrentUser()
    console.log('you are signed in.')
  } catch {
    console.log('you are not signed in')
  }
}

export const getAccessToken = async () => {
  try {
    const session = await fetchAuthSession()
    const accessToken = session.tokens?.accessToken?.toString() ?? ''
    console.log(accessToken ? 'you are signed in.' : 'you are not signed in')
    return accessToken
  } catch {
    console.log('you are not signed in')
    return ''
  }
}

export const signOut = async (onFailed) => {
  try {
    const session = await fetchAuthSession()
    if (!session.tokens) {
      alert("すでにログアウトしています。")
      onFailed()
    } else {
      await amplifySignOut()
    }
  } catch (err) {
    alert("すでにログアウトしています。")
    onFailed()
  }
  $.ajax({
    url: "/logout",
    type: 'POST',
    data: {
      authenticity_token: $("#authenticity_token").val()
    }
  })
}

export const changePassword = async (
    oldPassword,
    newPassword,
    onFailed
) => {
  try {
    await updatePassword({ oldPassword, newPassword })
    $.ajax({
      url: "/setting/password",
      type: 'POST',
      data: {
        authenticity_token: $("#authenticity_token").val()
      }
    })
  } catch (err) {
    alert(err.message)
    onFailed()
  }
}

export const forgotPassword = async (email, onUserFound, onFailed) => {
  try {
    await amplifyResetPassword({ username: email })
    onUserFound()
  } catch (err) {
    switch (err.name) {
      case "UserNotFoundException": {
        alert("入力されたメールアドレスは、ログインIDとして登録されていません。\n登録したメールアドレスを、再度入力してください。")
        break
      }
      default: {
        alert(err.message)
        break
      }
    }
    onFailed()
  }
}

export const resetPassword = async (email, verificationCode, newPassword, onFailed) => {
  try {
    await confirmResetPassword({ username: email, confirmationCode: verificationCode, newPassword })
    $.ajax({
      url: "/password",
      type: 'POST',
      data: {
        authenticity_token: $("#authenticity_token").val()
      }
    })
  } catch (err) {
    switch (err.name) {
      case "CodeMismatchException": {
        alert("認証コードが誤っています。再度入力してください。")
        break
      }
      default: {
        alert(err.message)
        break
      }
    }
    onFailed()
  }
}

// ID tokenからメールアドレスを取得する（パスワード変更時の入力チェックに使用）
export const getCognitoUserEmail = async () => {
  const session = await fetchAuthSession()
  return session.tokens?.idToken?.payload?.email
}
